import axios from '@/api/request';
import { getToken, setToken, removeToken } from '@/utils/TokenHelper';

const user = {
    state: {
        id: null,
        token: getToken(),
        name: '',
        nick: '',
        phone: '',
        regionType:'',
        roleCode:'',
        dataJurisdiction:'',//TODO:关键信息
        roleType:'',//TODO:关键信息
        // 地址
        address: {
            province: {
                name: '',
                code: '',
            },
            city: {
                name: '',
                code: '',
            },
            region: {
                name: '',//TODO:关键信息
                code: '',//TODO:关键信息
            },
        },
        perms: {
            // 菜单权限
            menu: [],
            // 按钮权限
            button: [],
        },
        roles: [],//TODO:关键信息
        depart: '', //所属机构
        uhead: '',
        isUhead: false,
    },
    mutations: {
        SET_DATA_PERM: (state, dataJurisdiction) => {
            state.dataJurisdiction = dataJurisdiction;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
            setToken(token);
        },
        CLEAR_TOKEN: (state) => {
            state.token = '';
            removeToken();
        },
        SET_ID: (state, id) => {
            state.id = id;
        },
        CLEAR_ID: (state) => {
            state.id = undefined;
        },
        SET_CITYNAME: (state, cityName) => {
            state.address.city.name = cityName;
        },
        SET_CITYCODE: (state, cityCode) => {
            state.address.city.code = cityCode;
        },
        SET_REGIONCODE: (state, regionCode) => {
            state.address.region.code = regionCode;
        },
        SET_REGIONNAME: (state, regionName) => {
            state.address.region.name = regionName;
        },
        SET_PROVINCECODE: (state, provinceCode) => {
            state.address.province.code = provinceCode;
        },
        SET_PROVINCENAME: (state, provinceName) => {
            state.address.province.name = provinceName;
        },
        SET_PERMS_PATH: (state, menu) => {
            state.perms.menu = menu;
        },
        SET_PERMS_BUTTON: (state, button) => {
            state.perms.button = button;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_NICK: (state, nick) => {
            state.nick = nick;
        },
        SET_PHONE: (state, phone) => {
            state.phone = phone;
        },
        SET_REGIONTYPE: (state, regionType) => {
            state.regionType = regionType;
        },
        SET_ROLECODE: (state, roleCode) => {
            state.roleCode = roleCode;
        },
        SET_ROLETYPE: (state, roleType) => {
            state.roleType = roleType;
        },
        SET_DEPART: (state, depart) => {
            state.depart = depart;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_UHEAD: (state, uhead) => {
            state.uhead = uhead;
            if (uhead != '' && uhead != null) {
                state.isUhead = true;
            } else {
                state.isUhead = false;
            }
        },
    },
    actions: {
        // 用户名登录
        LoginByUsername({ commit, dispatch }, userInfo) {
            const username = userInfo.username.trim();
            return new Promise((resolve, reject) => {
                axios({
                    url: window.BASE_CONFIG.USER_API+'api/v1/login/login',
                    method: 'post',
                    data: userInfo,
                })
                    .then((res) => {
                        commit('SET_TOKEN', res.data.data.token);
                        dispatch('GetUserInfo').then(() => {
                            resolve();
                        });
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
        // 获取用户信息
        GetUserInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: window.BASE_CONFIG.USER_API+'api/v1/user/getUserInfo',
                    method: 'get',
                })
                    .then((res) => {
                        let { roles, operateUser } = res.data.data;
                        commit('SET_REGIONCODE', operateUser.regionCode);
                        commit('SET_PHONE', operateUser.phone);
                        commit('SET_REGIONTYPE', operateUser.regionType);
                        commit('SET_ROLECODE', operateUser.roleCode);
                        commit('SET_NICK', operateUser.name);
                        commit('SET_ID', operateUser.id);
                        commit('SET_ROLETYPE', operateUser.roleType);
                        commit('SET_NAME', operateUser.username);


                        // commit('SET_CITYNAME', operateUser.cityName);
                        // commit('SET_CITYCODE', operateUser.cityCode);
                        // commit('SET_REGIONNAME', operateUser.regionName);
                        // commit('SET_PROVINCECODE', operateUser.provinceCode);
                        // commit('SET_PROVINCENAME', operateUser.provinceName);
                        // commit('SET_DEPART', operateUser.departmentName);
                        commit('SET_PERMS_PATH', roles.pageJurisdiction);
                        commit('SET_PERMS_BUTTON', roles.operateJurisdiction);
                        commit('SET_DATA_PERM', roles.dataJurisdiction);
                        commit('SET_ROLES', [roles.name]);
                        resolve();
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                commit('CLEAR_TOKEN');
                commit('CLEAR_ID');
                resolve();
            });
        },
    },
};

export default user;
